import { IErpOrdersState } from "./types";

const initialState: IErpOrdersState = {
  orders: [],
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isDeletingOrderLines: false,
  isUpdatingOrderLines: false,
  isEditingDelivery: false,
  count: 0,
  isConfirming: false,
};

export default initialState;
